import { LightningElement, api } from "lwc";
import classnames from "classnames";

export type QuoteCardAttribute = string | null;

export type QuoteCard = {
  imgSrc: QuoteCardAttribute;
  imgAlt: QuoteCardAttribute;
  text: QuoteCardAttribute;
  author: QuoteCardAttribute;
  authorLink: QuoteCardAttribute;
  role: QuoteCardAttribute;
  size: QuoteCardAttribute;
};

export default class extends LightningElement {
  @api imgSrc: QuoteCardAttribute = null;
  @api imgAlt: QuoteCardAttribute = null;
  @api text: QuoteCardAttribute = null;
  @api author: QuoteCardAttribute = null;
  @api authorLink: QuoteCardAttribute = null;
  @api role: QuoteCardAttribute = null;
  @api size: QuoteCardAttribute = null;

  private get className() {
    return classnames("quote-card", {
      "quote-card--hero": this.size === "hero",
    });
  }
}

export function extractQuoteCardAttributes(element: Element) {
  return {
    imgSrc: element.getAttribute("img-src"),
    imgAlt: element.getAttribute("img-alt"),
    text: element.getAttribute("text"),
    author: element.getAttribute("author"),
    authorLink: element.getAttribute("author-link"),
    role: element.getAttribute("role"),
    size: element.getAttribute("size"),
  } as QuoteCard;
}
